// Stockist Logo Slider

// jQuery(document).ready(function () {

//     jQuery('.stockists_slider').slick({
//         slidesToShow: 4,
//         autoplay: true,
//         autoplaySpeed: 300,
//         speed: 8000,
//         // cssEase: 'linear',
//         // infinite: true,
//         arrows: true,
//         prevArrow: '<button class="slick-prev custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0732/4935/7963/files/left-arrows.png?v=1773745983" alt="Prev"></button>',
//         nextArrow: '<button class="slick-next custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0732/4935/7963/files/right-arrows.png?v=1773745984" alt="Next"></button>',
//         dots: false,
//         pauseOnHover: false,
//         pauseOnFocus: false,

//         responsive: [
//             {
//                 breakpoint: 992,
//                 settings: { slidesToShow: 3 }
//             },
//             {
//                 breakpoint: 768,
//                 settings: { slidesToShow: 2 }
//             }
//         ]

//     });

// });





document.addEventListener("DOMContentLoaded", function () {
  //document.querySelector(".banner_section").classList.add("animate");
  const banner = document.querySelector(".banner_section");
  if (banner) {
    banner.classList.add("animate");
  }
});


jQuery(document).ready(function(){

  jQuery('.stockists_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
   autoplaySpeed: 2000,
   loop:true,
    arrows: true,
    prevArrow: '<button class="slick-prev custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0732/4935/7963/files/left-arrows.png?v=1773745983" alt="Prev"></button>',
    nextArrow: '<button class="slick-next custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0732/4935/7963/files/right-arrows.png?v=1773745984" alt="Next"></button>',
    infinite: true,
    dots: false,
    responsive: [
      {
        breakpoint: 990,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 }
      }
    ]
  });

});


// Testimonial Script
$(document).ready(function(){

  $('.testimonial_slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    loop:true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    responsive: [
      {
        breakpoint: 990,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  });

});


// Read More Script

$(document).on("click", ".read-toggle", function(e) {

  e.preventDefault();
  e.stopPropagation();

  var collapsedHeight = 87;
  var $text = $(this).prev(".add-read-more");

  if ($text.hasClass("expanded")) {

    $text.removeClass("expanded")
         .animate({ maxHeight: collapsedHeight }, 400);

    $(this).text("Read more");

  } else {

    $text.addClass("expanded")
         .animate({ maxHeight: $text.prop("scrollHeight") }, 400);

    $(this).text("Hide");

  }

});


$(window).on("load", function() {

  var collapsedHeight = 87;

  $(".add-read-more").each(function(){

    var $text = $(this);
    var $button = $text.next(".read-toggle");

    // Temporarily remove height limit
    $text.css("max-height", "none");

    var fullHeight = this.scrollHeight;

    // Restore collapsed height
    $text.css("max-height", collapsedHeight);

    if (fullHeight > collapsedHeight) {
      $button.addClass("visible");
    }

  });

});








$(document).ready(function(){
	//new WOW().init();
  if (typeof WOW !== "undefined") {
    new WOW().init();
  }
  $(window).on("resize", function (e) {
      checkScreenSize();
  });

    if($('#partners_logo').length > 0){

    
	$('#partners_logo').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:true,
		nav:false,
		pagination:false,  dots: false,
		navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:1
	        },
	        1000:{
	            items:4
	        },
	        1100:{
	            items:4
	        }
	    }
	}); 
}
function initMobileSlider() {
    if ($(window).width() < 768) {
      if (!$('.manual_content_row').hasClass('slick-initialized')) {
        $('.manual_content_row').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          prevArrow: '<button class="slick-prev custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0732/4935/7963/files/left-arrows.png?v=1773745983" alt="Prev"></button>',
          nextArrow: '<button class="slick-next custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0732/4935/7963/files/right-arrows.png?v=1773745984" alt="Next"></button>',
    
        });
      }
    } else {
      if ($('.manual_content_row').hasClass('slick-initialized')) {
        $('.manual_content_row').slick('unslick');
      }
    }
  }

  initMobileSlider();
  $(window).on('resize', initMobileSlider);
});


(function($){	
  if(jQuery('#destination-slider').length > 0){
setTimeout(function() {
  
        jQuery('#destination-slider').owlCarousel({
            margin: 30,
            loop:true,
		 	slideSpeed : 300,
			paginationSpeed : 400,
			nav:true,
			pagination:true,  
			dots: false,
			navText: [
                "<img src='http://atlas-indeed.wpcodexdev.com/wp-content/uploads/2024/11/Group-515226-1.png' alt='Previous'>", "<img src='http://atlas-indeed.wpcodexdev.com/wp-content/uploads/2024/11/Group-515225.png' alt='Next'>" ],
            responsive: {
                0:{
	            items:1
				},
				480:{
					items:1
				},
				768:{
					items:1
				},
				1000:{
					items:2
				},
				1100:{
					items:3
				}
            }

        });
    }, 3000);
  }
	}) (jQuery);	

// announcement bar toggle js start

$(document).on("click", ".announcement-faq-toggle", function(e){
  e.preventDefault();

  var $parent = $(this).closest(".announcement-faq");
  var $content = $parent.find(".announcement-faq-content");

  $content.stop(true, true).slideToggle(300);
  $(this).toggleClass("active");
});

// announcement bar toggle js End


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-category-menu a").forEach(function(link) {
    link.addEventListener("click", function(e) {
      const targetId = this.getAttribute("href");
      if (!targetId.startsWith("#")) {
        e.preventDefault();
        const section = document.getElementById(targetId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }
    });
  });
});


// cart icon + price js start

function updateCartPrice() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const priceEl = document.querySelector('.cart-price');
      if (priceEl) {
        //priceEl.innerHTML = Shopify.formatMoney(cart.total_price);
      }
    });
}

// Page load
document.addEventListener('DOMContentLoaded', updateCartPrice);

// After Add to Cart click
document.addEventListener('click', function(e) {
  if (e.target.closest('button[name="add"]')) {
    setTimeout(updateCartPrice, 700);
  }
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.custom_buynow');
  if (!btn) return;
  e.preventDefault();
  const form = btn.closest('form');
  const variantInput = form?.querySelector('[name="id"]');

  if (!variantInput || !variantInput.value) {
    alert('Please select a variant');
    return;
  }
  const variantId = variantInput.value;
  window.location.href = `/cart/${variantId}:1`;
});